import {
  Box,
  Container,
  Grid,
  Paper, Typography, Backdrop, Dialog
} from '@mui/material';
import React, {useContext, useEffect, useMemo, useState} from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from 'src/utils/appContext';
import {ArrowLeft, ClockTime} from '@vectopus/atlas-icons-react';
import {useResponsive} from "src/hooks/use-responsive";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useCountdownDate} from "src/hooks/use-countdown";
import {Logo} from "@/components/Logo";

const HeaderLogo = () => {
  const appContext = useContext(AppContext);
  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');
  const { classes } = useStyles();

  const [openLanguagesModal, setOpenLanguagesModal] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const navigate = useNavigate();
  const {t} = useTranslation();

  const handleModalLanguage = () => {
    setOpenLanguagesModal(!openLanguagesModal);
  };

  const handleModalProfile = () => {
    setOpenProfileModal(!openLanguagesModal);
  };

  const handleCart = () => {
    appContext.setDrawerCart(!appContext.drawerCart);
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {days, hours, minutes, seconds, timer, distance} = useCountdownDate(appContext.cartExpireAt ?? new Date())

  const goToPrevStep = () => {
    window.location.href.includes('booking') ? navigate('/search') : navigate('/booking')
  }

  return (
    <>
      <Paper className={classes.header}>
        <Container maxWidth={'xl'}>
          {
            downMd && (
              <Grid
                  container
                  direction={'row'}
                  alignItems={'center'}
                  justifyContent={'flex-start'}
                  className={classes.mobileNav}
              >
                <Grid item xs={2} pl={4}>
                  <Box onClick={() => goToPrevStep()}>
                    <ArrowLeft size={24} />
                  </Box>
                </Grid>
                <Grid item xs={6} textAlign={'center'} p={1}>
                  <a href={appContext.language === 'en' ? '/' : `/${appContext.language}`}>
                    <Logo/>
                  </a>
                </Grid>
                {
                  distance > 0 && (
                    <Grid item xs={4} textAlign={'right'} pr={4}>
                      <Typography variant={'h6'} component={'h6'}>
                        {timer}
                      </Typography>
                    </Grid>
                  )
                }
              </Grid>
            )
          }


          {
            upMd && (
              <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={4} md={4} lg={4}></Grid>
                <Grid item xs={2} md={4} lg={4} textAlign={'center'}>
                  <a href={appContext.language === 'en' ? '/' : `/${appContext.language}`}>
                    <Logo/>
                  </a>
                </Grid>
                <Grid item xs={4} md={4} lg={4}>
                  {
                  distance > 0 && (
                      <Grid container direction={'row'} alignItems={'flex-start'} justifyContent={'flex-end'}>
                        <Grid item xs={10} md={10}>
                          <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                            <ClockTime size={24}/>
                            <Typography variant={'h6'} component={'h6'} pl={1}>
                              {t('Tempo residuo')}:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={2} md={2} textAlign={'right'}>
                          <Typography variant={'h6'} component={'h6'}>
                            {timer}
                          </Typography>
                        </Grid>
                      </Grid>
                    )
                  }
                </Grid>
              </Grid>
            )
          }

        </Container>
      </Paper>
    </>
  );
};

export default HeaderLogo;

const useStyles = makeStyles()((theme) => {
  return {
    header: {
      [theme.breakpoints.up('md')]: {
        padding: '30px 0',
      },
      position: 'sticky',
      width: '100%',
      left: 0,
      zIndex: 0,
      '& .MuiAvatar-circular': {
        width: 30,
        height: 30
      },
      '& .MuiBadge-badge': {
        fontFamily: theme.typography.body1.fontFamily,
        backgroundColor: theme.palette.secondary.main
      },
      '& .MuiContainer-root': {
        padding: 0,
        [theme.breakpoints.down('xl')]: {
          maxWidth: 1200
        },
        [theme.breakpoints.down('md')]: {
          width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
          padding: '0'
        }
      },
      img: {
        cursor: 'pointer'
      },
      svg: {
        cursor: 'pointer',
        verticalAlign: 'initial'
      }
    },
    mobileNav: {
      [theme.breakpoints.down('md')]: {
        backgroundColor: theme.palette.primary.main
      }
    },
    rootDrawer: {
      '& .MuiPaper-root': {
        width: 390,
        padding: '20px 50px',
        backgroundColor: '#F2F2F2',
        [theme.breakpoints.down('sm')]: {
          padding: 36,
          width: '-webkit-fill-available'
        }
      }
    },
    profileNav: {
      '.MuiPaper-root': {
        boxShadow: '0px 2px 12px #00000029',
        border: 'none',
        marginTop: 20,
        'a': {
          textDecoration: 'none',
          color: '#000'
        }
      }
    },
    notifyContainer: {
      position: 'absolute',
      backgroundColor: '#FFEE00',
      padding: '15px 20px',
      display: 'flex',
      alignItems: 'center',
      width: 170,
      top: 65,
      left: '-160px',
      '&:after': {
        content: '""',
        position: 'absolute',
        height: 0,
        width: 0,
        top: -14,
        right: 15, /* 1px buffer for zooming problems while rendering*/
        borderWidth: 7,
        borderColor: 'transparent #ffee00 transparent transparent',
        borderStyle: 'solid',
        transform: 'rotate(90deg)'
      }
    }
  };
});
